import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../redux/actions/AuthenticationActions';

import SplitPageContainer from '../commonComponents/shared/SplitPageContainer';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import FadeoutErrorMessage from '../commonComponents/util/FadeOutErrorMessage';

class VerifyLoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            verificationCode: "",
            rememberDevice: false
        };

        this.onChange = this.onChange.bind(this);
        this.verify = this.verify.bind(this);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value });
    }

    async verify() {
        if(!this.state.verificationCode) return;
        
        await this.props.actions.verifyLogin(this.state.verificationCode, this.state.rememberDevice);

        if (this.props.success) {
            (this.props.location.state && this.props.location.state.from)
                ? this.props.history.replace(this.props.location.state.from)
                : this.props.history.push("/applications");
        } else {
            this.setState({ verificationCode: "" });
        }
    }

    render() { 
        return (
            <SplitPageContainer
                title="Login Verify"
                subtitle={<span><i className="material-icons middle">smartphone</i> A text message with your code has been sent to {this.props.phoneLast2Digits ? `(***)-***-**${this.props.phoneLast2Digits}` : 'your phone'}.</span>}>
                <div>
                    <div>
                        <label className="input-label">Enter Verification Code</label>
                        <input type="text" name="verificationCode" value={this.state.verificationCode} onChange={this.onChange} 
                            onKeyDown={e => { if (e.key === 'Enter') this.verify() }} />
                    </div>
                    <div className="custom-check-container">
                        <input type="checkbox" id="remember" className="custom-check" name="rememberDevice" checked={this.state.rememberDevice} onChange={this.onChange} />
                        <label htmlFor="remember" className="secondary-text">Remember this computer for 30 days</label>
                    </div>
                    <div className="left-column-footer relative">
                        {this.props.loading ? <LoadingSpinner height="32" /> :
                            <button className="btn btn-primary btn-wide" onClick={this.verify}
                                disabled={!this.state.verificationCode}>Verify</button>}

                        <FadeoutErrorMessage show={!this.props.success} message={this.props.message} />
                    </div>
                </div>
            </SplitPageContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.authentication.verifyLogin,
        phoneLast2Digits: state.authentication.login.data.phoneLast2Digits
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyLoginPage);



// WEBPACK FOOTER //
// ./src/components/authenticationComponents/VerifyLoginPage.jsx